/**
 * Whether this browser was last shown the full landing page while signed
 * out. index.js reads it at boot to skip the Google Maps and Dashboard
 * preloads on the sign-in paths, so the landing page loads without the map
 * code; the map loads after "Open the map" or sign-in. Login.js writes it.
 * Storage may be blocked: every access is guarded.
 */
const KEY = "earthmap-landing-shown";
const SIGN_IN_PATHS = ["/", "/login"];

export function setLandingHint(shown) {
  try {
    if (shown) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch {
    // Storage blocked: the next visit preloads the map, as before.
  }
}

export function skipsMapPreload(pathname) {
  try {
    return SIGN_IN_PATHS.includes(pathname) && localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
